export const theatreDashboardMockData = [
  {
    theatreId: 'TH-001',
    theatreRoom: 'Operating Room 1',
    currentProcedure: 'Appendectomy',
    surgeonName: 'Dr. Sarah Johnson',
    assistantSurgeon: 'Dr. Michael Harris',
    anesthesiologist: 'Dr. Daniel Wright',
    nurses: ['Nurse Emily Clark', 'Nurse Jason Rodriguez'],
    patientName: 'Kevin Thompson',
    patientId: 'PT-1542',
    status: 'Active',
    startTime: '2025-04-02T08:30:00',
    estimatedEndTime: '2025-04-02T09:00:00',
    nextProcedure: 'Hernia Repair',
    nextPatient: 'Laura Martinez',
    nextPatientId: 'PT-1563',
    scheduledTime: '2025-04-02T10:30:00',
    alerts: [],
    notes: 'Procedure progressing as expected'
  },
  {
    theatreId: 'TH-002',
    theatreRoom: 'Operating Room 2',
    currentProcedure: 'Total Hip Replacement',
    surgeonName: 'Dr. James Wilson',
    assistantSurgeon: 'Dr. Rachel Brown',
    anesthesiologist: 'Dr. Emma Taylor',
    nurses: ['Nurse Thomas White', 'Nurse Catherine Lee'],
    patientName: 'Robert Garcia',
    patientId: 'PT-1498',
    status: 'Active',
    startTime: '2025-04-02T07:45:00',
    estimatedEndTime: '2025-04-02T11:15:00',
    nextProcedure: 'Knee Arthroscopy',
    nextPatient: 'William Davis',
    nextPatientId: 'PT-1587',
    scheduledTime: '2025-04-02T12:00:00',
    alerts: [],
    notes: 'Complex case, may run longer than expected'
  },
  {
    theatreId: 'TH-003',
    theatreRoom: 'Operating Room 3',
    currentProcedure: null,
    surgeonName: null,
    assistantSurgeon: null,
    anesthesiologist: null,
    nurses: [],
    patientName: null,
    patientId: null,
    status: 'Cleaning',
    startTime: null,
    estimatedEndTime: null,
    nextProcedure: 'Laparoscopic Cholecystectomy',
    nextPatient: 'Jennifer Wilson',
    nextPatientId: 'PT-1502',
    scheduledTime: '2025-04-02T09:30:00',
    alerts: ['Cleaning in progress, may delay next procedure'],
    notes: 'Deep cleaning after infectious case'
  },
  {
    theatreId: 'TH-004',
    theatreRoom: 'Operating Room 4',
    currentProcedure: 'Coronary Artery Bypass',
    surgeonName: 'Dr. Maria Garcia',
    assistantSurgeon: 'Dr. Robert Chen',
    anesthesiologist: 'Dr. John Peterson',
    nurses: ['Nurse Sarah Collins', 'Nurse Michael Chen', 'Nurse David Wong'],
    patientName: 'Patricia White',
    patientId: 'PT-1367',
    status: 'Active',
    startTime: '2025-04-02T07:00:00',
    estimatedEndTime: '2025-04-02T13:00:00',
    nextProcedure: 'Pacemaker Insertion',
    nextPatient: 'Charles Miller',
    nextPatientId: 'PT-1612',
    scheduledTime: '2025-04-02T14:00:00',
    alerts: [],
    notes: 'Complex cardiac procedure, specialist team assembled'
  },
  {
    theatreId: 'TH-005',
    theatreRoom: 'Operating Room 5',
    currentProcedure: null,
    surgeonName: null,
    assistantSurgeon: null,
    anesthesiologist: null,
    nurses: [],
    patientName: null,
    patientId: null,
    status: 'Idle',
    startTime: null,
    estimatedEndTime: null,
    nextProcedure: 'Mastectomy',
    nextPatient: 'Susan Johnson',
    nextPatientId: 'PT-1534',
    scheduledTime: '2025-04-02T11:00:00',
    alerts: [],
    notes: 'Room prepared and ready for scheduled procedure'
  },
  {
    theatreId: 'TH-006',
    theatreRoom: 'Cath Lab 1',
    currentProcedure: 'Cardiac Catheterization',
    surgeonName: 'Dr. David Lee',
    assistantSurgeon: null,
    anesthesiologist: 'Dr. Amanda Parker',
    nurses: ['Nurse Jennifer Lopez', 'Nurse Richard Taylor'],
    patientName: 'Michael Adams',
    patientId: 'PT-1523',
    status: 'Active',
    startTime: '2025-04-02T09:15:00',
    estimatedEndTime: '2025-04-02T10:30:00',
    nextProcedure: 'Angioplasty',
    nextPatient: 'Barbara Wilson',
    nextPatientId: 'PT-1567',
    scheduledTime: '2025-04-02T11:00:00',
    alerts: [],
    notes: 'Diagnostic procedure in progress'
  },
  {
    theatreId: 'TH-007',
    theatreRoom: 'Endoscopy Suite 1',
    currentProcedure: 'Colonoscopy',
    surgeonName: 'Dr. Thomas Baker',
    assistantSurgeon: null,
    anesthesiologist: 'Dr. Michelle Rodriguez',
    nurses: ['Nurse Amanda Rodriguez'],
    patientName: 'Edward Martin',
    patientId: 'PT-1589',
    status: 'Active',
    startTime: '2025-04-02T09:00:00',
    estimatedEndTime: '2025-04-02T09:45:00',
    nextProcedure: 'Upper Endoscopy',
    nextPatient: 'Nancy Clark',
    nextPatientId: 'PT-1601',
    scheduledTime: '2025-04-02T10:00:00',
    alerts: [],
    notes: 'Routine screening procedure'
  },
  {
    theatreId: 'TH-008',
    theatreRoom: 'Operating Room 6',
    currentProcedure: 'Spinal Fusion',
    surgeonName: 'Dr. Michael Williams',
    assistantSurgeon: 'Dr. Jessica Adams',
    anesthesiologist: 'Dr. Christopher Lee',
    nurses: ['Nurse David Chen', 'Nurse Laura Martinez', 'Nurse Kevin Thompson'],
    patientName: 'Elizabeth Brown',
    patientId: 'PT-1478',
    status: 'Active',
    startTime: '2025-04-02T08:00:00',
    estimatedEndTime: '2025-04-02T12:30:00',
    nextProcedure: 'Laminectomy',
    nextPatient: 'Thomas Wilson',
    nextPatientId: 'PT-1545',
    scheduledTime: '2025-04-02T13:30:00',
    alerts: ['Patient with complex medical history'],
    notes: 'Neurosurgical monitoring in place, spine specialist consulted'
  },
  {
    theatreId: 'TH-009',
    theatreRoom: 'Operating Room 7',
    currentProcedure: 'Robotic Prostatectomy',
    surgeonName: 'Dr. Alexander Rivera',
    assistantSurgeon: 'Dr. Sophia Johnson',
    anesthesiologist: 'Dr. Rebecca White',
    nurses: ['Nurse Victoria Grant', 'Nurse Thomas Parker', 'Nurse Olivia Chen'],
    patientName: 'Richard Thompson',
    patientId: 'PT-1621',
    status: 'Active',
    startTime: '2025-04-02T08:15:00',
    estimatedEndTime: '2025-04-02T11:45:00',
    nextProcedure: 'Minimally Invasive Nephrectomy',
    nextPatient: 'Stephen Wilson',
    nextPatientId: 'PT-1649',
    scheduledTime: '2025-04-02T12:30:00',
    alerts: [],
    notes: 'Using Da Vinci robot, specialized team assembled'
  }
]
